// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3A4kz","col":"styles_col__3dLP6"};